import UomListings from "../../../Components/Pricings/Uoms/UomListings";

export default function UomListing() {
    return (
        <UomListings />
    )
}